module.exports = __webpack_public_path__ + "img/ic-new-year.64af9f1f.png";